import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslatePipe } from '@ngx-translate/core';
import momentTimezones from 'moment-timezone';
import { FormGroupComponent } from '../../../../forms';
import { FilterFieldOptions } from '../../../models';
import { DropdownOption } from '../filter-dropdown-field/filter-dropdown-field.component';
import { FilterSetFieldComponent } from '../filter-set-field/filter-set-field.component';

@Component({
  selector: 'iot-platform-ui-filter-timezone-field',
  standalone: true,
  imports: [FormGroupComponent, MatTreeModule, MatCheckboxModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: '../filter-set-field/filter-set-field.component.html',
  styleUrl: '../filter-tree-field/filter-tree-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterTimezoneFieldComponent extends FilterSetFieldComponent {
  fieldOptions: Signal<Partial<FilterFieldOptions>> = computed(() => {
    const field = this.field();
    return {
      ...field?.options,
      filterBy: 'value',
      selectByProperty: 'value',
      labelToDisplay: 'key',
      treeIdProperty: 'value',
      treeParentProperty: null
    };
  });

  override loadOptions() {
    this.isLoading.set(true);
    const timeout = setTimeout(() => {
      const timezones: DropdownOption[] = momentTimezones.tz.names().map((timezone: string) => ({
        key: this.fieldOptions()?.displayOffset ? `${timezone} ${momentTimezones.tz(timezone).format('Z')}` : timezone,
        value: timezone
      }));
      this.onDataLoaded(timezones);
      this.isLoading.set(false);
      clearTimeout(timeout);
    }, 100);
  }
}
